module.exports = __webpack_public_path__ + "static/media/ZSMT.8299420f.pdf";